@if (!isSearching) {
  <button class="search__button" aria-label="Search" (click)="navigateToSearchResults()">
    <ftr-icon icon="Search" color="Grey" align="Top" [ariaHidden]="true"></ftr-icon>
  </button>
} @else {
  <ftr-search-bar [courtSystemId]="courtSystemId" [searchTerms]="searchContext()?.searchTerms ?? ''"></ftr-search-bar>
}
